import { FormsMultilineInput } from '@platform/components';
import { Control, FieldError, FieldValues, FormState, Path } from 'react-hook-form';

export const OtherUpdateContent = <T extends FieldValues>({
  name,
  control,
  formState,
}: {
  name: Path<T>;
  control: Control<T>;
  formState: FormState<T>;
}) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px] text-xl'>
      <p className='text-center'>
        Tell us what's happening or if there's anything we should look into. Our MovingWorlds team
        will follow up if needed.
      </p>
      <div className='mt-4 items-stretch'>
        <FormsMultilineInput
          control={control}
          name={name}
          label='Additional details'
          placeholder="Let us know what's going on..."
          rules={{ required: `Let us know what's going on to continue` }}
          formsError={formState.errors[name] as FieldError}
          characterCount={500}
        />
      </div>
    </div>
  );
};
